// sbTypeContext.jsx
import React, { createContext, useContext, useState } from "react";

const SbTypeContext = createContext();

export const SbTypeProvider = ({ children }) => {
  const [sbType, setSbType] = useState("All"); // default value
  const [mode, setMode] = useState("All"); 
  const [fillingMode, setFillingMode] = useState("All"); 
  const [customsMode, setCustomsMode] = useState("Bengaluru Air Cargo"); 
  const { StatusMode, setStatusMode } = useState("All");
  const [transportmode, setTransportMode] = useState("Air"); 
  const[dropDownOptions,setDropdownOptions] = useState([]);



  return (
    <SbTypeContext.Provider value={{ sbType, setSbType, mode, setMode,fillingMode, setFillingMode,customsMode, setCustomsMode,StatusMode ,setStatusMode,
      transportmode, setTransportMode,dropDownOptions,setDropdownOptions
    }}>
      {children}
    </SbTypeContext.Provider>
  );
};

// ✅ Custom hook
export const useSbType = () => {
  return useContext(SbTypeContext);
};
